import React, { useEffect, useState } from 'react';

type Regra = {
    mensagem: string;
    check: boolean;
};

interface ValidacaoSenhaProps {
    erros: string;
}

const mensagensPadrao = [
    "No mínimo 5 caracteres.",
    "Pelo menos uma letra maiúscula.",
    "Pelo menos um caractere especial."
];

const mensagemExtra = "As senhas não coincidem.";

const MensagemVerificacaoSenha: React.FC<ValidacaoSenhaProps> = ({ erros }) => {
    const [regras, setRegras] = useState<Regra[]>([]);
    const [senhasDivergentes, setSenhasDivergentes] = useState(false);

    useEffect(() => {
        const errosRecebidos =
            erros
                ?.split("\n")
                .map((e) => e.trim())
                .filter((e) => e.length > 0 && e !== "A senha deve conter:") || [];

        const novasRegras = mensagensPadrao.map((mensagem) => ({
            mensagem,
            check: !errosRecebidos.includes(mensagem),
        }));

        setRegras(novasRegras);
        setSenhasDivergentes(errosRecebidos.includes(mensagemExtra));
    }, [erros]);

    return (
        <div>
            <small>
                <p className="success-text">A senha deve conter:</p>
            </small>
            {regras.map((regra) => (
                <small >
                    <p className={regra.check ? "success-text" : "error-text"}>
                        {regra.check ? "✓" : "✗"} {regra.mensagem}
                    </p>
                </small>
            ))}
            {senhasDivergentes && (
                <small>
                    <p className="error-text">✗ {mensagemExtra}</p>
                </small>
            )}
        </div>
    );
};

export default MensagemVerificacaoSenha;